export default __webpack_public_path__ + "static/media/button-Off.50827069.png";